<div
  [hidden]="!selected"
  class="follow-up-node-menu flow-menu"
  (click)="$event.stopPropagation()"
  #nodeMenuElement
>
  <lhpe-select
    [control]="channelItemControl"
    placeholder="Follow Up Channel"
    [required]="true"
    [options]="channelItems"
    [optionIsSelf]="true"
    displayValue="name"
  >
  </lhpe-select>
</div>
